import { YearlyTaxFreeNumbers } from "../model";

/**
 * Yearly tax-free decisions from the tax authorities starting from year 2023
 */
export const yearlyTaxFreeYears: Array<YearlyTaxFreeNumbers & { year: number }> =
  [
    {
      year: 2022,
      milage: {
        car: 46,
        carAdditions: {
          trailer: 8,
          caravan: 12,
          canteen: 23,
          largeMachinery: 3,
          docInTheCar: 3,
          contstructionSite: 10,
        },
        carLimitedBenefit: 10,
        passanger: 3,
        other: {
          motorboatUpTo50Hp: 80,
          motorboatOver50Hp: 116,
          snowMobile: 110,
          quadbike: 104,
          motorcycle: 35,
          moped: 19,
          otherTransport: 11,
        }
      },
      countries:{
        Afghanistan: 47,
        Albania: 67,
        Algeria: 60,
        Andorra: 59,
        Angola: 57,
        AntiquaAndBarbuda: 78,
        Argentina: 37,
        Armenia: 54,
        Aruba: 60,
        Australia: 69,
        Austria: 68,
        Azerbaidzhan: 54,
        Azores: 61,
        Bahamas: 76,
        Bahrain: 73,
        Bangladesh: 66,
        Barbados: 73,
        Belarus: 51,
        Belgium: 67,
        Belize: 46,
        Benin: 43,
        Bermuda: 75,
        Bhutan: 44,
        Bolivia: 41,
        BosniaAndHercegovina: 51,
        Botswana: 43,
        Brazil: 59,
        Brunei: 40,
        Bulgaria: 57,
        BurkinaFaso: 38,
        Burundi: 43,
        Cambodia: 59,
        Cameroon: 54,
        Canada: 71,
        CanaryIslands: 63,
        CapeVerde: 43,
        CentralAfricanRepublic: 92,
        Chad: 56,
        Chile: 48,
        China: 73,
        HongKong: 76,
        Colombia: 48,
        Comoros: 33,
        CongoBrazzaville: 61,
        CongoKinshasa: 40,
        CookIslands: 68,
        CostaRica: 49,
        Croatia: 63,
        Cuba: 44,
        Curaçao: 50,
        Cyprus: 61,
        CzechRepublic: 68,
        Denmark: 71,
        Djibouti: 71,
        Dominica: 54,
        DominicanRepublic: 53,
        EastTimor: 46,
        Ecuador: 55,
        Egypt: 72,
        ElSalvador: 48,
        Eritrea: 77,
        Estonia: 58,
        Eswatini: 41,
        Ethiopia: 41,
        FaroeIslands: 55,
        Fiji: 50,
        France: 70,
        Gabon: 87,
        Gambia: 43,
        Georgia: 42,
        Germany: 66,
        Ghana: 52,
        Greece: 59,
        Greenland: 56,
        Grenada: 64,
        Guadeloupe: 51,
        Guatemala: 64,
        Guinea: 69,
        GuineaBissau: 37,
        Guyana: 43,
        Haiti: 48,
        Honduras: 48,
        Hungary: 56,
        Iceland: 75,
        India: 56,
        Indonesia: 51,
        Iran: 80,
        Iraq: 51,
        Ireland: 67,
        Israel: 87,
        Italy: 66,
        IvoryCoast: 73,
        Jamaica: 51,
        Japan: 76,
        Jordania: 80,
        Kazakhstan: 45,
        Kenya: 74,
        NorthKorea: 63,
        SouthKorea: 81,      
        Kosovo: 50,
        Kuwait: 72,
        Kyrgystan: 39,
        Laos: 47,
        Latvia: 57,
        Lebanon: 92,
        Lesotho: 36,
        Liberia: 53,
        Libya: 47,
        Liechtenstein: 66,
        Lithuania: 55,
        Luxembourg: 69,
        Madagascar: 40,
        Madeira: 60,
        Malawi: 68,
        Malaysia: 49,
        Maldives: 60,
        Mali: 41,
        Malta: 66,
        MarshallIslands: 55,
        Martinique: 53,
        Mauritania: 46,
        Mauritius: 45,
        Mexico: 55,
        Micronesia: 50,
        Moldova: 56,
        Monaco: 92,
        Mongolia: 39,
        Montenegro: 59,
        Morocco: 69,
        Mozambique: 45,
        Myanmar: 57,
        Namibia: 39,
        Nepal: 47,
        Netherlands: 72,
        NewZealand: 72,
        Nicaragua: 42,
        Niger: 46,
        Nigeria: 76,
        NorthMacedonia: 54,
        Norway: 71,
        Oman: 66,
        Pakistan: 33,
        Palau: 77,
        Palestinianterritory: 77,
        Panama: 54,
        PapuaNewGuinea: 64,
        Paraguay: 32,
        Peru: 49,
        Philippines: 65,
        Poland: 57,
        Portugal: 62,
        PuertoRico: 57,
        Qatar: 67,
        Romania: 59,
        RussianFederation: 56,
        Moscow: 79,
        StPetersburg: 64,
        Rwanda: 36,
        SaintKittsAndNevis: 59,
        SaintLucia: 71,
        SaintVincentAndTheGrenadines: 71,
        Samoa: 53,
        SanMarino: 61,
        SaoTomeAndPrincipe: 85,
        SaudiArabia: 68,
        Senegal: 53,
        Serbia: 63,
        Seychelles: 74,
        SierraLeone: 57,
        Singapore: 68,
        Slovakia: 64,
        Slovenia: 61,
        SolomonIslands: 53,
        Somalia: 67,
        SouthAfrica: 53,
        SouthSudan: 92,
        Spain: 65,
        SriLanka: 39,
        Sudan: 25,
        Suriname: 72,
        Sweden: 63,
        Switzerland: 78,
        Syria: 84,
        Tadzhikistan: 35,
        Taiwan: 67,
        Tanzania: 49,
        Thailand: 60,
        Togo: 52,
        Tonga: 53,
        TrinidadAndTobago: 70,
        Tunisia: 54,
        Turkey: 37,
        Istanbul: 39,
        Turkmenistan: 80,
        Uganda: 43,
        Ukraine: 70,
        UnitedArabEmirates: 73,
        UnitedKingdom: 68,
        LondonAndEdinburgh: 72,
        UnitedStates: 72,
        NewYorkLosAngelesWashington: 78,
        Uruguay: 51,
        Uzbekistan: 31,
        Vanuatu: 60,
        Venezuela: 85,
        Vietnam: 64,
        VirginIslands: 51,
        Yemen: 92,
        Zimbabwe: 51,
        Zambia: 58,
        Other: 46
      }
    },
    {
      year: 2023,
      milage: {
        car: 53,
        carAdditions: {
          trailer: 9,
          caravan: 14,
          canteen: 27,
          largeMachinery: 4,
          docInTheCar: 4,
          contstructionSite: 11,
        },
        carLimitedBenefit: 14,
        passanger: 4,
        other: {
          motorboatUpTo50Hp: 93,
          motorboatOver50Hp: 135,
          snowMobile: 129,
          quadbike: 121,
          motorcycle: 41,
          moped: 22,
          otherTransport: 13,
        }
      },
      countries: {
        Afghanistan: 55,
        Albania: 71,
        Algeria: 74,
        Andorra: 59,
        Angola: 73,
        AntiquaAndBarbuda: 95,
        Argentina: 45,
        Armenia: 62,
        Aruba: 74,
        Australia: 77,
        Austria: 75,
        Azerbaidzhan: 68,
        Azores: 67,
        Bahamas: 92,
        Bahrain: 86,
        Bangladesh: 68,
        Barbados: 90,
        Belarus: 66,
        Belgium: 74,
        Belize: 54,
        Benin: 45,
        Bermuda: 94,
        Bhutan: 52,
        Bolivia: 49,
        BosniaAndHercegovina: 52,
        Botswana: 46,
        Brazil: 77,
        Brunei: 46,
        Bulgaria: 59,
        BurkinaFaso: 40,
        Burundi: 54,
        Cambodia: 72,
        Cameroon: 55,
        Canada: 86,
        CanaryIslands: 70,
        CapeVerde: 44,
        CentralAfricanRepublic: 96,
        Chad: 56,
        Chile: 55,
        China: 82,
        HongKong: 92,
        Colombia: 55,
        Comoros: 38,
        CongoBrazzaville: 62,
        CongoKinshasa: 50,
        CookIslands: 69,
        CostaRica: 60,
        Croatia: 65,
        Cuba: 52,
        Curaçao: 60,
        Cyprus: 63,
        CzechRepublic: 82,
        Denmark: 77,
        Djibouti: 85,
        Dominica: 64,
        DominicanRepublic: 58,
        EastTimor: 51,
        Ecuador: 65,
        Egypt: 73,
        ElSalvador: 59,
        Eritrea: 95,
        Estonia: 72,
        Eswatini: 41,
        Ethiopia: 43,
        FaroeIslands: 60,
        Fiji: 56,
        France: 74,
        Gabon: 88,
        Gambia: 50,
        Georgia: 48,
        Germany: 71,
        Ghana: 41,
        Greece: 66,
        Greenland: 61,
        Grenada: 76,
        Guadeloupe: 51,
        Guatemala: 78,
        Guinea: 82,
        GuineaBissau: 38,
        Guyana: 53,
        Haiti: 55,
        Honduras: 59,
        Hungary: 56,
        Iceland: 89,
        India: 64,
        Indonesia: 61,
        Iran: 122,
        Iraq: 65,
        Ireland: 73,
        Israel: 100,
        Italy: 72,
        IvoryCoast: 77,
        Jamaica: 64,
        Japan: 70,
        Jordania: 96,
        Kazakhstan: 51,
        Kenya: 85,
        NorthKorea: 75,
        SouthKorea: 85,      
        Kosovo: 52,
        Kuwait: 86,
        Kyrgystan: 42,
        Laos: 35,
        Latvia: 69,
        Lebanon: 122,
        Lesotho: 37,
        Liberia: 71,
        Libya: 53,
        Liechtenstein: 77,
        Lithuania: 68,
        Luxembourg: 74,
        Madagascar: 46,
        Madeira: 66,
        Malawi: 69,
        Malaysia: 54,
        Maldives: 71,
        Mali: 43,
        Malta: 67,
        MarshallIslands: 67,
        Martinique: 54,
        Mauritania: 53,
        Mauritius: 53,
        Mexico: 71,
        Micronesia: 60,
        Moldova: 64,
        Monaco: 92,
        Mongolia: 44,
        Montenegro: 61,
        Morocco: 69,
        Mozambique: 55,
        Myanmar: 61,
        Namibia: 40,
        Nepal: 53,
        Netherlands: 80,
        NewZealand: 75,
        Nicaragua: 51,
        Niger: 49,
        Nigeria: 81,
        NorthMacedonia: 56,
        Norway: 76,
        Oman: 79,
        Pakistan: 31,
        Palau: 94,
        Palestinianterritory: 86,
        Panama: 65,
        PapuaNewGuinea: 79,
        Paraguay: 39,
        Peru: 51,
        Philippines: 70,
        Poland: 64,
        Portugal: 68,
        PuertoRico: 72,
        Qatar: 81,
        Romania: 62,
        RussianFederation: 69,
        Moscow: 85,
        StPetersburg: 78,
        Rwanda: 40,
        SaintKittsAndNevis: 70,
        SaintLucia: 86,
        SaintVincentAndTheGrenadines: 86,
        Samoa: 60,
        SanMarino: 62,
        SaoTomeAndPrincipe: 101,
        SaudiArabia: 83,
        Senegal: 55,
        Serbia: 66,
        Seychelles: 93,
        SierraLeone: 53,
        Singapore: 79,
        Slovakia: 73,
        Slovenia: 68,
        SolomonIslands: 63,
        Somalia: 87,
        SouthAfrica: 55,
        SouthSudan: 119,
        Spain: 72,
        SriLanka: 34,
        Sudan: 50,
        Suriname: 74,
        Sweden: 66,
        Switzerland: 91,
        Syria: 98,
        Tadzhikistan: 39,
        Taiwan: 73,
        Tanzania: 59,
        Thailand: 65,
        Togo: 54,
        Tonga: 59,
        TrinidadAndTobago: 84,
        Tunisia: 59,
        Turkey: 38,
        Istanbul: 39,
        Turkmenistan: 92,
        Uganda: 50,
        Ukraine: 62,
        UnitedArabEmirates: 84,
        UnitedKingdom: 73,
        LondonAndEdinburgh: 77,
        UnitedStates: 92,
        NewYorkLosAngelesWashington: 100,
        Uruguay: 56,
        Uzbekistan: 35,
        Vanuatu: 70,
        Venezuela: 100,
        Vietnam: 74,
        VirginIslands: 66,
        Yemen: 122,
        Zimbabwe: 75,
        Zambia: 70,
        Other: 53
      }
    },
    {
      year: 2024,
      milage: {
        car: 57,
        carAdditions: {
          trailer: 10,
          caravan: 15,
          canteen: 29,
          largeMachinery: 4,
          docInTheCar: 4,
          contstructionSite: 12,
        },
        carLimitedBenefit: 13,
        passanger: 4,
        other: {
          motorboatUpTo50Hp: 100,
          motorboatOver50Hp: 145,
          snowMobile: 138,
          quadbike: 130,
          motorcycle: 44,
          moped: 23,
          otherTransport: 14,
        }
      },
      countries: {
        Afghanistan: 59,
        Albania: 81,
        Algeria: 78,
        Andorra: 63,
        Angola: 71,
        AntiquaAndBarbuda: 94,
        Argentina: 38,
        Armenia: 61,
        Aruba: 70,
        Australia: 74,
        Austria: 80,
        Azerbaidzhan: 70,
        Azores: 69,
        Bahamas: 91,
        Bahrain: 80,
        Bangladesh: 57,
        Barbados: 83,
        Belarus: 63,
        Belgium: 77,
        Belize: 52,
        Benin: 47,
        Bermuda: 90,
        Bhutan: 49,
        Bolivia: 48,
        BosniaAndHercegovina: 54,
        Botswana: 41,
        Brazil: 80,
        Brunei: 45,
        Bulgaria: 64,
        BurkinaFaso: 40,
        Burundi: 46,
        Cambodia: 67,
        Cameroon: 59,
        Canada: 82,
        CanaryIslands: 71,
        CapeVerde: 45,
        CentralAfricanRepublic: 101,
        Chad: 47,
        Chile: 56,
        China: 74,
        HongKong: 86,
        Colombia: 64,
        Comoros: 42,
        CongoBrazzaville: 64,
        CongoKinshasa: 51,
        CookIslands: 70,
        CostaRica: 65,
        Croatia: 69,
        Cuba: 68,
        Curaçao: 58,
        Cyprus: 65,
        CzechRepublic: 89,
        Denmark: 79,
        Djibouti: 83,
        Dominica: 61,
        DominicanRepublic: 53,
        EastTimor: 46,
        Ecuador: 53,
        Egypt: 66,
        ElSalvador: 60,
        Eritrea: 95,
        Estonia: 75,
        Eswatini: 37,
        Ethiopia: 49,
        FaroeIslands: 61,
        Fiji: 52,
        France: 78,
        Gabon: 92,
        Gambia: 46,
        Georgia: 49,
        Germany: 76,
        Ghana: 47,
        Greece: 68,
        Greenland: 63,
        Grenada: 73,
        Guadeloupe: 53,
        Guatemala: 76,
        Guinea: 83,
        GuineaBissau: 41,
        Guyana: 51,
        Haiti: 62,
        Honduras: 58,
        Hungary: 69,
        Iceland: 82,
        India: 62,
        Indonesia: 57,
        Iran: 102,
        Iraq: 70,
        Ireland: 78,
        Israel: 88,
        Italy: 76,
        IvoryCoast: 80,
        Jamaica: 62,
        Japan: 66,
        Jordania: 90,
        Kazakhstan: 59,
        Kenya: 70,
        NorthKorea: 70,
        SouthKorea: 87,      
        Kosovo: 58,
        Kuwait: 84,
        Kyrgystan: 41,
        Laos: 32,
        Latvia: 73,
        Lebanon: 102,
        Lesotho: 34,
        Liberia: 60,
        Libya: 52,
        Liechtenstein: 79,
        Lithuania: 72,
        Luxembourg: 77,
        Madagascar: 45,
        Madeira: 68,
        Malawi: 77,
        Malaysia: 50,
        Maldives: 68,
        Mali: 47,
        Malta: 71,
        MarshallIslands: 65,
        Martinique: 55,
        Mauritania: 52,
        Mauritius: 53,
        Mexico: 81,
        Micronesia: 59,
        Moldova: 73,
        Monaco: 92,
        Mongolia: 42,
        Montenegro: 66,
        Morocco: 71,
        Mozambique: 53,
        Myanmar: 58,
        Namibia: 36,
        Nepal: 51,
        Netherlands: 83,
        NewZealand: 74,
        Nicaragua: 51,
        Niger: 50,
        Nigeria: 78,
        NorthMacedonia: 64,
        Norway: 70,
        Oman: 74,
        Pakistan: 29,
        Palau: 99,
        Palestinianterritory: 76,
        Panama: 61,
        PapuaNewGuinea: 76,
        Paraguay: 36,
        Peru: 52,
        Philippines: 69,
        Poland: 72,
        Portugal: 70,
        PuertoRico: 70,
        Qatar: 78,
        Romania: 68,
        RussianFederation: 66,
        Moscow: 82,
        StPetersburg: 76,
        Rwanda: 37,
        SaintKittsAndNevis: 68,
        SaintLucia: 86,
        SaintVincentAndTheGrenadines: 85,
        Samoa: 61,
        SanMarino: 59,
        SaoTomeAndPrincipe: 102,
        SaudiArabia: 80,
        Senegal: 58,
        Serbia: 75,
        Seychelles: 87,
        SierraLeone: 47,
        Singapore: 79,
        Slovakia: 79,
        Slovenia: 72,
        SolomonIslands: 63,
        Somalia: 86,
        SouthAfrica: 50,
        SouthSudan: 102,
        Spain: 74,
        SriLanka: 29,
        Sudan: 83,
        Suriname: 78,
        Sweden: 64,
        Switzerland: 93,
        Syria: 91,
        Tadzhikistan: 35,
        Taiwan: 69,
        Tanzania: 54,
        Thailand: 63,
        Togo: 58,
        Tonga: 62,
        TrinidadAndTobago: 83,
        Tunisia: 61,
        Turkey: 35,
        Istanbul: 37,
        Turkmenistan: 92,
        Uganda: 49,
        Ukraine: 64,
        UnitedArabEmirates: 73,
        UnitedKingdom: 79,
        LondonAndEdinburgh: 83,
        UnitedStates: 89,
        NewYorkLosAngelesWashington: 97,
        Uruguay: 59,
        Uzbekistan: 32,
        Vanuatu: 70,
        Venezuela: 102,
        Vietnam: 69,
        VirginIslands: 64,
        Yemen: 102,
        Zimbabwe: 102,
        Zambia: 55,
        Other: 52
      }
    },
    {
      year: 2025,
      milage: {
        car: 59,
        carAdditions: {
          trailer: 10,
          caravan: 15,
          canteen: 30,
          largeMachinery: 4,
          docInTheCar: 4,
          contstructionSite: 13,
        },
        carLimitedBenefit: 12,
        passanger: 4,
        other: {
          motorboatUpTo50Hp: 103,
          motorboatOver50Hp: 149,
          snowMobile: 142,
          quadbike: 134,
          motorcycle: 45,
          moped: 24,
          otherTransport: 14,
        }
      },
      countries: {
        Afghanistan:61,
        Albania:89,
        Algeria:82,
        Andorra:65,
        Angola:69,
        AntiquaAndBarbuda:95,
        Argentina:45,
        Armenia:59,
        Aruba:69,
        Australia:77,
        Austria:82,
        Azerbaidzhan:69,
        Azores:70,
        Bahamas:89,
        Bahrain:78,
        Bangladesh:56,
        Barbados:79,
        Belarus:50,
        Belgium:79,
        Belize:52,
        Benin:47,
        Bermuda:89,
        Bhutan:37,
        Bolivia:48,
        BosniaAndHercegovina:62,
        Botswana:42,
        Brazil:70,
        Brunei:45,
        Bulgaria:66,
        BurkinaFaso:41,
        Burundi:55,
        Cambodia:66,
        Cameroon:62,
        Canada:80,
        CanaryIslands:73,
        CapeVerde:45,
        CentralAfricanRepublic:102,
        Chad:52,
        Chile:55,
        China:73,
        HongKong:83,
        Colombia:61,
        Comoros:46,
        CongoBrazzaville:66,
        CongoKinshasa:58,
        CookIslands:73,
        CostaRica:64,
        Croatia:71,
        Cuba:64,
        Curaçao:57,
        Cyprus:66,
        CzechRepublic:89,
        Denmark:80,
        Djibouti:83,
        Dominica:60,
        DominicanRepublic:50,
        EastTimor:47,
        Ecuador:62,
        Egypt:51,
        ElSalvador:58,
        Eritrea:97,
        Estonia:78,
        Eswatini:40,
        Ethiopia:46,
        FaroeIslands:62,
        Fiji:54,
        France:79,
        Gabon:95,
        Gambia:44,
        Georgia:46,
        Germany:77,
        Ghana:41,
        Greece:70,
        Greenland:63,
        Grenada:72,
        Guadeloupe:54,
        Guatemala:77,
        Guinea:85,
        GuineaBissau:45,
        Guyana:51,
        Haiti:79,
        Honduras:58,
        Hungary:69,
        Iceland:93,
        India:61,
        Indonesia:56,
        Iran:119,
        Iraq:71,
        Ireland:79,
        Israel:89,
        Italy:77,
        IvoryCoast:83,
        Jamaica:61,
        Japan:69,
        Jordania:88,
        Kazakhstan:60,
        Kenya:80,
        NorthKorea:67,
        SouthKorea:85,
        Kosovo:61,
        Kuwait:84,
        Kyrgystan:43,
        Laos:34,
        Latvia:73,
        Lebanon:95,
        Lesotho:37,
        Liberia:59,
        Libya:52,
        Liechtenstein:81,
        Lithuania:72,
        Luxembourg:79,
        Madagascar:46,
        Madeira:69,
        Malawi:61,
        Malaysia:54,
        Maldives:66,
        Mali:49,
        Malta:72,
        MarshallIslands:67,
        Martinique:57,
        Mauritania:49,
        Mauritius:49,
        Mexico:73,
        Micronesia:60,
        Moldova:76,
        Monaco:92,
        Mongolia:44,
        Montenegro:68,
        Morocco:72,
        Mozambique:52,
        Myanmar:71,
        Namibia:39,
        Nepal:51,
        Netherlands:86,
        NewZealand:77,
        Nicaragua:50,
        Niger:56,
        Nigeria:68,
        NorthMacedonia:66,
        Norway:70,
        Oman:72,
        Pakistan:33,
        Palau:107,
        Palestinianterritory:89,
        Panama:60,
        PapuaNewGuinea:67,
        Paraguay:34,
        Peru:50,
        Philippines:70,
        Poland:81,
        Portugal:72,
        PuertoRico:71,
        Qatar:75,
        Romania:71,
        RussianFederation:73,
        Moscow:91,
        StPetersburg:83,
        Rwanda:33,
        SaintKittsAndNevis:65,
        SaintLucia:83,
        SaintVincentAndTheGrenadines:85,
        Samoa:61,
        SanMarino:60,
        SaoTomeAndPrincipe:119,
        SaudiArabia:78,
        Senegal:57,
        Serbia:78,
        Seychelles:81,
        SierraLeone:58,
        Singapore:82,
        Slovakia:81,
        Slovenia:73,
        SolomonIslands:62,
        Somalia:88,
        SouthAfrica:54,
        SouthSudan:119,
        Spain:75,
        SriLanka:31,
        Sudan:119,
        Suriname:104,
        Sweden:68,
        Switzerland:96,
        Syria:78,
        Tadzhikistan:35,
        Taiwan:67,
        Tanzania:49,
        Thailand:65,
        Togo:63,
        Tonga:65,
        TrinidadAndTobago:80,
        Tunisia:65,
        Turkey:41,
        Istanbul:42,
        Turkmenistan:86,
        Uganda:49,
        Ukraine:57,
        UnitedArabEmirates:72,
        UnitedKingdom:83,
        LondonAndEdinburgh:87,
        UnitedStates:88,
        NewYorkLosAngelesWashington:95,
        Uruguay:55,
        Uzbekistan:33,
        Vanuatu:72,
        Venezuela:119,
        Vietnam:69,
        VirginIslands:63,
        Yemen:97,
        Zimbabwe:119,
        Zambia:46,
        Other:52        
      }
    }
  ];